// extracted by css-extract-rspack-plugin
export default {"promo":"aWm4C","texts":"Eq8qN","text":"QQaOR"};